import type { AmazonSalesResponse } from "reedy-data/api";
import type { Granularity } from "components/charts";
import { useSalesQuery } from "./useSalesQuery";

export const useAmazonSales = (
  isbns: string[] | undefined,
  initialGranularity?: Granularity,
) => useSalesQuery<AmazonSalesResponse>(isbns, "amazon", initialGranularity);
